import Icon from 'veui/components/Icon'

Icon.register({
  eye: {
    paths: [
      {
        d: 'M24 7c9.33 0 17.66 6.37 21.84 16.22a2 2 0 010 1.56C41.66 34.63 33.34 41 24 41c-9.33 0-17.66-6.37-21.84-16.22a2 2 0 010-1.56C6.34 13.37 14.66 7 24 7zm0 4c-7.37 0-14.13 5-17.81 13C9.87 32 16.63 37 24 37c7.37 0 14.13-5 17.81-13C38.13 16 31.37 11 24 11zm0 4.5a8.5 8.5 0 018 11.36 2 2 0 11-3.76-1.34A4.49 4.49 0 0024 19.5a4.5 4.5 0 101.08 8.87 2 2 0 01.96 3.88A8.51 8.51 0 0115.5 24c0-4.7 3.8-8.5 8.5-8.5z'
      }
    ],
    width: '48',
    height: '48'
  }
})
